'use client'; // Error components must be Client Components

import {useEffect} from 'react';
import clsx from 'clsx';

import {CallToActionRender} from 'components/call-to-action/render';

export default function Error({error, reset}: {error: Error; reset: () => void}) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<>
			<title>500 - noe gikk galt | Kjelstad</title>
			<div
				className={clsx(
					'px-5',
					'py-20',
					'flex',
					'flex-col',
					'justify-center',
					'items-center',
					'h-full',
					'gap-9',
					'text-center',
				)}
			>
				<h1
					className={clsx(
						'text-3xl',
						'font-bold',
						'tracking-tight',
						'text-primary-main',
						'sm:text-5xl',
					)}
				>
					Oops, noe gikk galt!
				</h1>
				<CallToActionRender
					color="primary"
					text="Prøv igjen"
					onClick={
						// Attempt to recover by trying to re-render the segment
						() => reset()
					}
				/>
			</div>
		</>
	);
}
